import React, { Component } from 'react'
import ReactDOM from 'react-dom'

import ModalContainer from '../../../../common/modal'

class DeleteConfirmationModalContainer extends Component {
  constructor() {
    super()

    this.el = document.createElement('div')
    this.portalRoot = document.getElementById('modal-root')
  }

  componentDidMount = () => {
    this.portalRoot.appendChild(this.el)
  }

  componentWillUnmount = () => {
    this.portalRoot.removeChild(this.el)
  }

  render() {
    const { onDeleteConfirmClick, onDeleteCloseClick, onDeleteCancelClick } =
      this.props

    return ReactDOM.createPortal(
      <ModalContainer
        header="Confirmation"
        onConfirmClick={onDeleteConfirmClick}
        onCloseModalBoxClick={onDeleteCloseClick}
        onCancelClick={onDeleteCancelClick}
      >
        Are you sure you want to <strong>delete</strong> tenant?
      </ModalContainer>,
      this.el,
    )
  }
}
export default DeleteConfirmationModalContainer
